/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  PostTournamentsMutationRequest,
  PostTournamentsMutationResponse,
  PostTournaments400,
  PostTournaments401,
  PostTournaments403,
  PostTournaments500,
} from "../types/PostTournaments.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const postTournamentsMutationKey = () =>
  [{ url: "/tournaments" }] as const;

export type PostTournamentsMutationKey = ReturnType<
  typeof postTournamentsMutationKey
>;

/**
 * @description Пример запроса:
 * POST /tournaments
 * {
 * "name": "Summer Championship 2025",
 * "description": "Annual summer tournament",
 * "organizationId": "uuid-here",
 * "type": "Classic",
 * "bracketType": "SingleElimination",
 * "startDate": "2025-07-15T18:00:00Z",
 * "maxPlayers": 32,
 * "prizePool": 5000,
 * "region": "EUW",
 * "requireRiotAccount": true
 * }
 * @summary Создание турнира (от имени текущего пользователя и выбранной организации)
 * {@link /tournaments}
 */
export async function postTournaments(
  data: PostTournamentsMutationRequest,
  config: Partial<RequestConfig<PostTournamentsMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostTournamentsMutationResponse,
    ResponseErrorConfig<
      | PostTournaments400
      | PostTournaments401
      | PostTournaments403
      | PostTournaments500
    >,
    PostTournamentsMutationRequest
  >({
    method: "POST",
    url: `/tournaments`,
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res;
}

export function postTournamentsMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PostTournamentsMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const mutationKey = postTournamentsMutationKey();
  return mutationOptions<
    ResponseConfig<PostTournamentsMutationResponse>,
    ResponseErrorConfig<
      | PostTournaments400
      | PostTournaments401
      | PostTournaments403
      | PostTournaments500
    >,
    { data: PostTournamentsMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return postTournaments(data, config);
    },
  });
}

/**
 * @description Пример запроса:
 * POST /tournaments
 * {
 * "name": "Summer Championship 2025",
 * "description": "Annual summer tournament",
 * "organizationId": "uuid-here",
 * "type": "Classic",
 * "bracketType": "SingleElimination",
 * "startDate": "2025-07-15T18:00:00Z",
 * "maxPlayers": 32,
 * "prizePool": 5000,
 * "region": "EUW",
 * "requireRiotAccount": true
 * }
 * @summary Создание турнира (от имени текущего пользователя и выбранной организации)
 * {@link /tournaments}
 */
export function usePostTournaments<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<PostTournamentsMutationResponse>,
      ResponseErrorConfig<
        | PostTournaments400
        | PostTournaments401
        | PostTournaments403
        | PostTournaments500
      >,
      { data: PostTournamentsMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PostTournamentsMutationRequest>> & {
      client?: Client;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postTournamentsMutationKey();

  const baseOptions = postTournamentsMutationOptions(
    config,
  ) as UseMutationOptions<
    ResponseConfig<PostTournamentsMutationResponse>,
    ResponseErrorConfig<
      | PostTournaments400
      | PostTournaments401
      | PostTournaments403
      | PostTournaments500
    >,
    { data: PostTournamentsMutationRequest },
    TContext
  >;

  return useMutation<
    ResponseConfig<PostTournamentsMutationResponse>,
    ResponseErrorConfig<
      | PostTournaments400
      | PostTournaments401
      | PostTournaments403
      | PostTournaments500
    >,
    { data: PostTournamentsMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    ResponseConfig<PostTournamentsMutationResponse>,
    ResponseErrorConfig<
      | PostTournaments400
      | PostTournaments401
      | PostTournaments403
      | PostTournaments500
    >,
    { data: PostTournamentsMutationRequest },
    TContext
  >;
}
